// Actions

import { SubscriptionPackage } from "../../../../../functions/src/Subscriptions/SubscriptionsInterfaces";

//Mutations
export const UPDATE_DISPLAYED_TEAM = "UPDATE_DISPLAYED_TEAM";
export const UPDATE_BREADCRUMBS = "UPDATE_BREADCRUMBS";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const CLEAR_DATA = "CLEAR_DATA";
export const CLEAR_DISPLAYED_TEAM = "CLEAR_DISPLAYED_TEAM";
export const CLEAR_BREADCRUMBS = "CLEAR_BREADCRUMBS";
export const UPDATE_CURRENT_DISPLAYED_USER = "UPDATE_CURRENT_DISPLAYED_USER";
export const CLEAR_FULL_TEAM = "CLEAR_FULL_TEAM";
export const CLEAR_CURRENT_DISPLAYED_USER = "CLEAR_CURRENT_DISPLAYED_USER";
export const SET_LEADER_TEAM_CACHE = "SET_LEADER_TEAM_CACHE";
export const UPDATE_SORT_CONFIGURATION = "UPDATE_SORT_CONFIGURATION";

export type sortableColumns =
  | "username"
  | "nickname"
  | "rank_priority"
  | "downlines"
  | "unilevel_side"
  | "academy_days_left"
  | "scholarship_points"
  | "license_days_left"
  | "cmmi_end_date"
  | "total_volume"
  | "qualified_volume_total"
  | "qualified_percentage_total"
  | "depth"
  | "current_package"
  | "subscription_days_left"
  | "distributor_days_left";

export interface MyTeamState {
  fullTeamCache: Map<
    string,
    { uplines: Array<string>; leaderTeam: Array<MyTeamMember> }
  >;
  displayedTeam: Array<MyTeamMember>;
  breadcrumbs: Array<string>;
  isLoading: boolean;
  currentDisplayedUser: string;
  // Era `[Map<…>] | []`, o sea «exactamente un mapa, o ninguno». Nunca fue
  // verdad: la pantalla permite apilar varios criterios y `updateSortConfiguration`
  // añade uno por columna que se active. El tipo describía un caso que el código
  // no respeta, y la única razón de que compilara es que `commit()` recibe la
  // carga como `any`. Es una lista de mapas, y así se declara.
  sortConfiguration: Array<Map<sortableColumns, "asc" | "desc">>;
}

/**
 * UN MIEMBRO DEL EQUIPO, TAL Y COMO LLEGA DE `MyTeam-GetFullTeamForUser`.
 *
 * ⚠️ LOS `| null` NO SON DECORACIÓN. `MyTeamFunc.ts` normaliza cada campo
 * numérico con la forma `m.campo = m.campo ? parseInt(m.campo) : null`, así que
 * cualquiera de ellos puede llegar nulo — y, por el `?` de esa expresión, un
 * CERO legítimo también acaba en `null`. Varios estaban declarados aquí como
 * `number` a secas, y ese optimismo es justo lo que dejaba pasar comparadores
 * que sólo funcionan con números: el tipo decía que nunca faltaba nada, y en
 * pantalla faltaba constantemente.
 */
export interface MyTeamMember {
  _active_from_date: string;
  _team_leader: string;
  _updated_date: string;
  _usernamePK: string;
  username: string;
  nickname: string;
  current_rank: string;
  profile_picture: string;
  pictureUrl: string;
  unilevel_side: string;
  rank_priority: number | null;
  academy_end_date: string | null;
  academy_days_left: number | null;
  cmmi_end_date: string | null;
  license_end_date: string | null;
  license_days_left: number | null;

  gtr_lite_end_date: string | null;
  gtr_lite_days_left: number | null;
  lite_license_end_date: string | null;
  lite_license_days_left: number | null;

  // Los dos «días restantes» que SÍ se pintan en la tabla. El backend los
  // rellena con la pareja del paquete completo o con la del Lite según lo que
  // tenga el socio, y si esa pareja no existe llegan nulos.
  subscription_days_left: number | null;
  subscription_end_date: string;

  distributor_days_left: number | null;
  distributor_end_date: string;

  current_package: SubscriptionPackage;

  scholarship_points: number | null;
  scholarship_end_date: string;
  total_volume_left: number | null;
  total_volume_right: number | null;
  total_volume: number | null;
  total_volume_left_flag: string;
  total_volume_right_flag: string;
  qualified_volume_right: number | null;
  qualified_volume_left: number | null;
  qualified_volume_total: number | null;
  qualified_percentage_right: number | null;
  qualified_percentage_left: number | null;
  qualified_percentage_total: number | null;
  qualified_volume_left_flag: string;
  qualified_volume_right_flag: string;
  next_rank_id: string;
  required_earning: number;
  required_points: number;
  // Ojo: la profundidad 0 (el propio líder del equipo mostrado) también llega
  // como `null`, por el `m.depth ? … : null` del backend.
  depth: number | null;
  uplines: Array<string>;
  downlines: number;
}
